export default "__VITE_ASSET__W2zpJ2en__"